import { READ_ONLY_MODE } from "Areas/Documents/documentDetails/types/readOnlyMode";
import { modeEnum } from "Areas/Documents/documentEditorPanel";
import locale from "./buildDocumentActionsMenuItems.locale";
export default (projectId, document, onOpenDocumentEditorPanel, onDeleteDocument, onSetDocumentSelected, canOpen, canEditDocuments, canDeleteDocuments) => {
    if (!projectId)
        return [];
    const result = [];
    if (canOpen && canOpen(document.Id, document.ProjectId)) {
        result.push({
            icon: "icon-eye font-h5 text-default",
            text: locale.OPEN_DOCUMENT_READONLY_MODE,
            onClick: () => {
                onSetDocumentSelected && onSetDocumentSelected(document.Id, true, READ_ONLY_MODE.READ_ONLY);
            }
        });
        result.push({
            icon: "icon-pen font-h5 text-default",
            text: locale.OPEN_DOCUMENT_EDIT_MODE,
            onClick: () => {
                onSetDocumentSelected &&
                    onSetDocumentSelected(document.Id, true, READ_ONLY_MODE.READ_WRITE);
            }
        });
        result.push({
            divider: true
        });
    }
    if (canEditDocuments) {
        result.push({
            icon: "icon-document-clone-plus font-h5 text-default",
            text: locale.DUPLICATE_DOCUMENT,
            onClick: () => {
                onOpenDocumentEditorPanel && onOpenDocumentEditorPanel(document.Id, modeEnum.DUPLICATE);
            }
        });
        result.push({
            icon: "icon-edit font-h5 text-default",
            text: locale.RENAME_DOCUMENT,
            onClick: () => {
                onOpenDocumentEditorPanel && onOpenDocumentEditorPanel(document.Id, modeEnum.EDIT);
            }
        });
        result.push({
            divider: true
        });
    }
    if (canDeleteDocuments) {
        result.push({
            icon: "icon-trash font-h5 text-red",
            text: locale.DELETE_DOCUMENT,
            textClassName: "text-red",
            confirm: {
                title: locale.CONFIRM_DELETE_DOCUMENT_TEXT,
                header: locale.CONFIRM_DELETE_DOCUMENT_HEADER,
                callback: () => {
                    onDeleteDocument && onDeleteDocument(document.ProjectId, document.Id);
                }
            }
        });
    }
    return result;
};
